import { render, staticRenderFns } from "./CreatePlan.vue?vue&type=template&id=281f9518&scoped=true"
import script from "./CreatePlan.vue?vue&type=script&lang=js"
export * from "./CreatePlan.vue?vue&type=script&lang=js"
import style0 from "./CreatePlan.vue?vue&type=style&index=0&id=281f9518&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f9518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281f9518')) {
      api.createRecord('281f9518', component.options)
    } else {
      api.reload('281f9518', component.options)
    }
    module.hot.accept("./CreatePlan.vue?vue&type=template&id=281f9518&scoped=true", function () {
      api.rerender('281f9518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/CreatePlan.vue"
export default component.exports